// src/community-navigation.ts
//
// Filtros do feed (global e do espaço) na URL: voltar de uma publicação ou
// recarregar a página mantém a ordenação e a categoria escolhidas.
import type { FeedFilter } from "@/api";

const feedFilters: FeedFilter[] = ["recentes", "destaques", "em-alta", "seguindo"];

export function feedSearch(search: Record<string, unknown>): {
  filter?: Exclude<FeedFilter, "recentes">;
  category?: string;
} {
  const filter = feedFilters.find((value) => value === search.filter && value !== "recentes");
  return {
    filter: filter as Exclude<FeedFilter, "recentes"> | undefined,
    category: typeof search.category === "string" && search.category ? search.category : undefined,
  };
}

export function spaceFeedSearch(search: Record<string, unknown>): {
  filter?: Exclude<FeedFilter, "recentes" | "seguindo">;
} {
  const filter =
    search.filter === "destaques" || search.filter === "em-alta" ? search.filter : undefined;
  return { filter };
}
